export default "__VITE_ASSET__noDuMyec__"